/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const GET_PAYMENTS_INFO = "GET_PAYMENTS_INFO";
export const GET_PAYMENTS_INFO_SUCCESS = "GET_PAYMENTS_INFO_SUCCESS";
export const GET_PAYMENTS_INFO_FAILURE = "GET_PAYMENTS_INFO_FAILURE";

export const CREATE_INITIAL_PAYMENT = "CREATE_INITIAL_PAYMENT";
export const CREATE_INITIAL_PAYMENT_SUCCESS = "CREATE_INITIAL_PAYMENT_SUCCESS";
export const CREATE_INITIAL_PAYMENT_FAILURE = "CREATE_INITIAL_PAYMENT_FAILURE";
export const CREATE_INITIAL_PAYMENT_WITHOUT_PAYMENT_DETAILS =
  "CREATE_INITIAL_PAYMENT_WITHOUT_PAYMENT_DETAILS";
export const CREATE_INITIAL_PAYMENT_WITHOUT_PAYMENT_DETAILS_SUCCESS =
  "CREATE_INITIAL_PAYMENT_WITHOUT_PAYMENT_DETAILS_SUCCESS";

export const CREATE_PAYMENT_DETAILS = "CREATE_PAYMENT_DETAILS";
export const CREATE_PAYMENT_DETAILS_SUCCESS = "CREATE_PAYMENT_DETAILS_SUCCESS";
export const CREATE_PAYMENT_DETAILS_FAILURE = "CREATE_PAYMENT_DETAILS_FAILURE";

export const CREATE_PAYMENT_ORDER = "CREATE_PAYMENT_ORDER";
export const CREATE_PAYMENT_ORDER_SUCCESS = "CREATE_PAYMENT_ORDER_SUCCESS";
export const CREATE_PAYMENT_ORDER_FAILURE = "CREATE_PAYMENT_ORDER_FAILURE";
export const RESET_PAYMENT_ORDER = "RESET_PAYMENT_ORDER";

export const UPDATE_PAYMENT_ORDER = "UPDATE_PAYMENT_ORDER";
export const UPDATE_PAYMENT_ORDER_SUCCESS = "UPDATE_PAYMENT_ORDER_SUCCESS";
export const UPDATE_PAYMENT_ORDER_FAILURE = "UPDATE_PAYMENT_ORDER_FAILURE";

export const GET_PAYMENT_INVOICES = "GET_PAYMENT_INVOICES";
export const GET_PAYMENT_INVOICES_SUCCESS = "GET_PAYMENT_INVOICES_SUCCESS";
export const GET_PAYMENT_INVOICES_FAILURE = "GET_PAYMENT_INVOICES_FAILURE";

export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS";
export const GET_PAYMENT_DETAILS_SUCCESS = "GET_PAYMENT_DETAILS_SUCCESS";
export const GET_PAYMENT_DETAILS_FAILURE = "GET_PAYMENT_DETAILS_FAILURE";
export const GET_PAYMENT_DETAILS_STOP_INTERVAL =
  "GET_PAYMENT_DETAILS_STOP_INTERVAL";

export const GET_PAYMENT_OFFER = "GET_PAYMENT_OFFER";
export const GET_PAYMENT_OFFER_SUCCESS = "GET_PAYMENT_OFFER_SUCCESS";
export const GET_PAYMENT_OFFER_FAILURE = "GET_PAYMENT_OFFER_FAILURE";

export const RESET_PAYMENT = "RESET_PAYMENT";

export const SELECT_OFFER_ID = "SELECT_OFFER_ID";
export const SELECT_VOUCHER_CODE = "SELECT_VOUCHER_CODE";
export const SET_PAYMENT_CALLBACK = "SET_PAYMENT_CALLBACK";

export const GET_SWITCH_OFFER = "GET_SWITCH_OFFER";
export const GET_SWITCH_OFFER_SUCCESS = "GET_SWITCH_OFFER_SUCCESS";
export const GET_SWITCH_OFFER_FAILURE = "GET_SWITCH_OFFER_FAILURE";

export const SWITCH_SUBSCRIPTION = "SWITCH_SUBSCRIPTION";
export const SWITCH_SUBSCRIPTION_SUCCESS = "SWITCH_SUBSCRIPTION_SUCCESS";
export const SWITCH_SUBSCRIPTION_FAILURE = "SWITCH_SUBSCRIPTION_FAILURE";

export const SWITCH_SUBSCRIPTION_SUCCESS_EVENT =
  "SWITCH_SUBSCRIPTION_SUCCESS_EVENT";
export const SWITCH_SUBSCRIPTION_FAILURE_EVENT =
  "SWITCH_SUBSCRIPTION_FAILURE_EVENT";

export const CANCEL_SUBSCRIPTION_SWITCH = "CANCEL_SUBSCRIPTION_SWITCH";
export const CANCEL_SUBSCRIPTION_SWITCH_SUCCESS = "CANCEL_SUBSCRIPTION_SWITCH_SUCCESS";
export const CANCEL_SUBSCRIPTION_SWITCH_FAILURE = "CANCEL_SUBSCRIPTION_SWITCH_FAILURE";
